import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Deadlines = () => {
  return (
    <React.Fragment>
      <SEO title="Important Dates | ICSI 2022" />
      <Header />
      <Breadcrumb
        image="images/bg/banner2.jpg"
        title="Important Dates"
        content="For Authors"
        contentTwo="Deadlines"
        linkage="/"
      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        <div className="entry-content">
          <p>
            <h4>Deadlines for ICSI&apos;2022:</h4>
          </p>
          <br />
          <table className="deadline">
            <tbody>
              <tr>
                <th width="200">Event</th>
                <th width="400">Deadline</th>
              </tr>
              <tr>
                <td>
                  <strong>
                    <del>Special Session proposals</del>
                  </strong>
                </td>
                <td>
                  <strong>
                    <del>January 15, 2022</del>
                  </strong>
                </td>
              </tr>
              <tr>
                <td>
                  <strong>
                    <del>Paper submission</del>
                  </strong>
                </td>
                <td>
                  <strong>
                    {/* <del>March 15, 2022</del> */}
                    <del>March 31, 2022</del>
                  </strong>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  <strong></strong>
                </td>
              </tr>
              <tr>
                <td>
                  <strong>
                    <del>
                    Notification of acceptance

                    </del>
                    </strong>
                </td>
                <td>
                  <strong>
                    <del>
                    April 15, 2022
                    </del>
                    </strong>
                </td>
              </tr>
              <tr>
                <td>
                  <strong>
                    <del>
                    Camera-ready copy

                    </del>
                    </strong>
                </td>
                <td>
                  <strong>
                    <del>
                    April 30, 2022

                    </del>
                    </strong>
                </td>
              </tr>
              <tr>
                <td>
                  <strong>
                    <del>
                    Author registration

                    </del>
                    </strong>
                </td>
                <td>
                  <strong>
                    <del>
                    April 30, 2022

                    </del>
                    </strong>
                </td>
              </tr>

              <tr>
                <td>
                  <strong>
                    <del>
                    ICSI-OC&apos;2022
                    </del>
                    </strong>
                </td>
                <td>
                  <strong>
                    <del>
                    May 27, 2022
                    </del>
                    </strong>
                </td>
              </tr>
            </tbody>
          </table>
          {/* <div className="row">
            <h5>Click the link below to submit your paper to ICSI 2022</h5>
            <a
              className="btn btn-primary"
              href="https://easychair.org/conferences/?conf=icsi2022"
            >
              ICSI Online Paper Submission
            </a>
          </div> */}
        </div>
      </EmptyTwo>
      {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
        <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Deadlines;
